import React, { useRef, useState } from 'react';
import { Box, Checkbox, ListItemText, MenuItem, OutlinedInput } from '@mui/material';
import { UPDropdownHelperText, UPSelectStyled } from 'components/dropdown/styles';
import { UPInputLabel } from 'components/input/styles';
import { UPMultipleSelectWithCheckboxProps } from './types';
import { DropdownPlaceholder, MenuProps } from './styles';

const UPMultipleSelectWithCheckbox = (props: UPMultipleSelectWithCheckboxProps) => {
  const {
    id,
    items,
    label,
    required,
    selectedItems,
    onChange,
    placeholder,
    error,
    helperText,
    renderValue,
    disabled,
    testId,
  } = props;
  const containerRef = useRef<HTMLDivElement>(null);
  const [menuWidth, setMenuWidth] = useState<number>();

  return (
    <Box width={1} ref={containerRef}>
      <UPInputLabel>
        {label} {required && '*'}
      </UPInputLabel>

      <UPSelectStyled
        id={id}
        displayEmpty
        multiple
        fullWidth
        value={selectedItems}
        onChange={onChange}
        disabled={disabled}
        SelectDisplayProps={{ 'data-testid': testId } as React.HTMLAttributes<HTMLDivElement>}
        input={<OutlinedInput />}
        onOpen={() => setMenuWidth(containerRef.current?.clientWidth)}
        MenuProps={{ ...MenuProps, PaperProps: { style: { ...MenuProps.PaperProps.style, width: menuWidth } } }}
        renderValue={(value: unknown) => {
          const selected = value as string[];
          if (selected.length === 0) {
            return <DropdownPlaceholder>{placeholder}</DropdownPlaceholder>;
          }

          if (renderValue) {
            return renderValue(value);
          }

          return selected.join(', ');
        }}
        error={error}
      >
        {items.map(item => (
          <MenuItem
            key={item.value}
            value={item.value}
            disabled={item.isDisabled}
            data-testid={testId && `${testId}-option-${item.value}`}
            sx={{ whiteSpace: 'normal' }}
          >
            <Checkbox checked={selectedItems.includes(item.value)} />
            <ListItemText primary={item.label} />
          </MenuItem>
        ))}
      </UPSelectStyled>
      {error && <UPDropdownHelperText>{helperText}</UPDropdownHelperText>}
    </Box>
  );
};

export default UPMultipleSelectWithCheckbox;
